"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../../context/CartContext"));
var _MessageContext = _interopRequireDefault(require("../../../context/MessageContext"));
var _updateShippingProvider = _interopRequireWildcard(require("../../../utils/cart/updateShippingProvider"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Select = _interopRequireDefault(require("../../../components/Select"));
var _ShippingProviders = _interopRequireDefault(require("./ShippingProviders.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ShippingProviders = _ref => {
  let {
    lang
  } = _ref;
  const {
    cart,
    setCart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    setMessageObj
  } = (0, _react.useContext)(_MessageContext.default);
  const {
    items = [],
    shippingProviders = []
  } = cart || {};
  const css = (0, _ShippingProviders.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    if ((shippingProviders === null || shippingProviders === void 0 ? void 0 : shippingProviders.length) === 1) {
      var _shippingProviders$;
      const shippingProvidersID = shippingProviders === null || shippingProviders === void 0 || (_shippingProviders$ = shippingProviders[0]) === null || _shippingProviders$ === void 0 ? void 0 : _shippingProviders$.id;
      if (shippingProvidersID) handleChange(shippingProvidersID, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const hasDigitalProducts = (0, _react.useMemo)(() => {
    return items === null || items === void 0 ? void 0 : items.some(_ref2 => {
      let {
        type
      } = _ref2;
      return type === "digital";
    });
  }, [items]);
  const handleChange = async function (id) {
    let disableSuccessMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const response = await (0, _updateShippingProvider.default)(id);
    const {
      msg
    } = response || {};
    if (msg) {
      setMessageObj({
        message: l("reactShop.messages.errors.".concat(_updateShippingProvider.UPDATE_SHIPPING_PROVIDER_ERRORS[msg])),
        type: "error"
      });
      return;
    }
    localStorage.setItem("mco-shop-cart", JSON.stringify(response));
    setCart(response);
    if (!disableSuccessMsg) {
      setMessageObj({
        message: l("reactShop.messages.success.SHIPPING_PROVIDER_UPDATED"),
        type: "success"
      });
    }
  };
  if ((0, _isEmpty.default)(shippingProviders) && !hasDigitalProducts) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.shippingProviders, "mco-shop-checkout-shipping-providers")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.headline, "mco-shop-checkout__headline")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.checkout.shippingProviders.headline",
    l: l
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: css.wrapper
  }, !(0, _isEmpty.default)(shippingProviders) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, shippingProviders === null || shippingProviders === void 0 ? void 0 : shippingProviders.map(shippingProvider => {
    const {
      id,
      identifier = "post",
      selected = false,
      title
    } = shippingProvider;
    return /*#__PURE__*/_react.default.createElement(_Select.default, {
      checked: selected,
      id: id,
      identifier: identifier,
      key: id,
      label: title,
      onChange: handleChange
    });
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasDigitalProducts && /*#__PURE__*/_react.default.createElement(_Select.default, {
    checked: true,
    label: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.checkout.shippingProviders.labels.perMail",
      l: l
    })
  }))));
};
var _default = exports.default = ShippingProviders;